
import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./Hero.css";
import N1 from "../assets/N1.jpg";
import N2 from "../assets/N2.jpg";
import N3 from "../assets/N3.jpg";
import N4 from "../assets/N4.jpg";

const carouselData = [
  { img: N2 },
  { img: N3 },
  { img: N1 },
  { img: N4 },
];

const NextArrow = ({ onClick }) => (
  <div className="arrow next" onClick={onClick}>
    <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M5 12h14m-7-7l7 7-7 7" />
    </svg>
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="arrow prev" onClick={onClick}>
    <svg width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2.5">
      <path d="M19 12H5m7 7l-7-7 7-7" />
    </svg>
  </div>
);

const Hero = () => {
  const navigate = useNavigate();
  const [isDark, setIsDark] = useState(false);

  // ⭐ TYPEWRITER (Stable, No Glitch) ⭐
  const fullText = "Courses";
  const [typedText, setTypedText] = useState("");

  const indexRef = useRef(0);
  const deleteRef = useRef(false);

useEffect(() => {
  const typingSpeed = 180;
  const deletingSpeed = 120;
  const waitAfterFull = 2000;

  let timer = null;

  function run() {
    const index = indexRef.current;
    const isDeleting = deleteRef.current;

    // ---- TYPING ----
    if (!isDeleting) {
      if (index < fullText.length) {
        setTypedText(fullText.slice(0, index + 1));
        indexRef.current++;
        timer = setTimeout(run, typingSpeed);
        return;
      }

      // ⭐ FULL WORD COMPLETED → HOLD 2 SECONDS ⭐
      deleteRef.current = true;
      timer = setTimeout(run, waitAfterFull);
      return;
    }

    // ---- DELETING ----
    if (isDeleting) {
      if (index > 0) {
        setTypedText(fullText.slice(0, index - 1));
        indexRef.current--;
        timer = setTimeout(run, deletingSpeed);
        return;
      }

      // Restart
      deleteRef.current = false;
      timer = setTimeout(run, typingSpeed);
      return;
    }
  }

  run();

  return () => clearTimeout(timer);
}, []);


  // ⭐ SLIDER SETTINGS ⭐
  const settings = {
    dots: true,
    infinite: true,
    speed: 900,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    fade: true,
    cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

  return (
    <div className={`hero-premium ${isDark ? "dark-mode" : "light-mode"}`}>
      
      {/* 🌗 Theme Toggle */}
      <div className="theme-toggle" onClick={() => setIsDark(!isDark)}>
        <div className={`toggle-btn ${isDark ? "active" : ""}`}>
          {isDark ? "🌙" : "☀️"}
        </div>
      </div>

      <Slider {...settings}>
        {carouselData.map((slide, index) => (
          <div key={index} className="hero-slide">
            
            <div className="hero-bg">
              <img src={slide.img} alt="Success with Coding" />
              <div className="bg-overlay"></div>
            </div>

            <div className="hero-container">
              <motion.div
                className="hero-content"
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
              >

                <div className="badge">
                  <span>Codex Future IT Training & Placement</span>
                </div>

                {/* ⭐ TITLE WITH TYPEWRITER ⭐ */}
                <h1 className="hero-title">
                  Job Guaranteed{" "}
                  <span className="gradient-text typewriter-word">{typedText}</span>{" "}
                  In Indore
                  <br />
                  <span className="highlight">100% Placement Assurance</span>
                </h1>

                <p className="hero-desc">
                  Live Projects • Industry Mentors • Free Demo Class
                </p>

                <div className="trust-row">
                  <div className="trust-item"><span className="check">✓</span> Placements</div>
                  <div className="trust-item"><span className="check">✓</span> 4.9/5 Rating</div>
                  <div className="trust-item"><span className="check">✓</span> ISO Certified</div>
                </div>

                <div className="cta-group">
                  <motion.button
                    className="btn-primary"
                    onClick={() => navigate("/allcourses")}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Explore Courses
                  </motion.button>
                </div>

              </motion.div>
            </div>

          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Hero;
